module.exports = __webpack_public_path__ + "static/media/product opt.920fbe0f.jpg";